<template>
    <div id="viewFooter">&copy; 2019. 최소원 All rights reserved</div>
</template>
<script>
export default {};
</script>
<style>
#viewFooter {
    background-color: #edb352;
    padding: 20px 0;
    text-align: center;
}
</style>
